import React from 'react';
import PropTypes from 'prop-types';

import WHYGOSOLAR from './WHYGOSOLAR';
import OtherBenefits from './OtherBenefits';
import SystemSpecs from './SystemSpecs';
import Equivalencies from './Equivalencies';
import { formattedNumber } from '../../../../../utils/formatterHelpers';
import DisclaimerDialog from '../DisclaimerDialog';
import PitchedRoof from './PitchedRoof';
import GroundMount from './GroundMount';
import CorrugatedMetal from './CorrugatedMetal';
import RoofTopCanopy from './RoofTopCanopy';
import Carport from './Carport';
import FlatBallasted from './FlatBallasted';

import './saleslogic.css';
import '../../../../../grid.css';
import { Container, Title, ComparisonContainer } from './styles';

const SalesLogic = (props) => {
    const {
        annualResults,
        installType,
        installType2,
        systemSize,
        provider,
    } = props;

    return (
        <Container>
            <Title>
                You have to buy electricity. The choice is yours.
            </Title>
            <ComparisonContainer>
                <div className="col span-1-of-2-Choice">
                    <div className="utilTitleRed">
                        ${formattedNumber(annualResults[30].cumulativeSolarSavings)}
                    </div>
                    <p> Given to  {provider}</p>
                    <p>(Value Of Solar)</p>
                </div>
                <div className="col span-1-of-2-Choice">
                    <div className="utilTitleGreen">
                        ${formattedNumber(annualResults[30].cumulativeCashSavings)}
                    </div>
                    <p>Cash In Hand after Solar is Paid For</p>
                </div>
            </ComparisonContainer>
            <WHYGOSOLAR />
            <OtherBenefits />
            <SystemSpecs />
            <div className="clearfixclass" />
            <div className="row">
                <div>
                    <Title>How your {systemSize / 1000} kW system will be installed.</Title>
                    {installType === 'pr' || installType2 === 'pr' ? <PitchedRoof /> : null }
                    {installType === 'cm' || installType2 === 'cm' ? <CorrugatedMetal /> : null }
                    {installType === 'gm' || installType2 === 'gm' ? <GroundMount /> : null }
                    {installType === 'fb' || installType2 === 'fb' ? <FlatBallasted /> : null }
                    {installType === 'rc' || installType2 === 'rc' ? <RoofTopCanopy /> : null }
                    {installType === 'pc' || installType2 === 'pc' ? <Carport /> : null }
                    {installType === 'o' || installType2 === 'o' ? 'Other' : null }
                </div>
            </div>

            <div className="row">
                <Equivalencies />
            </div>

            <div className="clearfixclass" />

            <div className="row">
                <div className="disclaimerBtn">
                    <DisclaimerDialog />
                </div>
            </div>

        </Container>
    );
};

SalesLogic.propTypes = {
    annualResults: PropTypes.object.isRequired,
    installType: PropTypes.string.isRequired,
    installType2: PropTypes.string,
    provider: PropTypes.string.isRequired,
    systemSize: PropTypes.number.isRequired,
};

SalesLogic.defaultProps = {
    installType2: null,
};


export default SalesLogic;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/SalesLogic.js